import { Clipboard } from '@angular/cdk/clipboard';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

import { SearchResult } from 'models';
import { BaseMenuComponent } from 'src/app/common/base-menu-component';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-locked-document-menu',
  templateUrl: './locked-document-menu.component.html',
  styleUrls: ['./locked-document-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LockedDocumentMenuComponent extends BaseMenuComponent {
  /** Document search result. */
  searchResult = input.required<SearchResult>({ alias: 'search-result' });

  /**
   * Whether the document is locked for PDF conversion.
   */
  isPdfConversionLocked = computed(() => this.searchResult().isConvertingToPdf);
  /**
   * Whether the document is locked in a workflow.
   */
  isWorkflowLocked = computed(() => this.searchResult().workflowProcessId > 0);
  /**
   * Whether the document is locked.
   */
  isDocumentLocked = computed(
    () => this.isWorkflowLocked() || this.isPdfConversionLocked()
  );
  /**
   * Whether to show the menu trigger button.
   */
  protected showMenuTriggerButton = computed(
    () => this.isDocumentLocked() && !this.hideMenuTriggerButton()
  );

  constructor(
    private clipboard: Clipboard,
    private notify: NotificationService
  ) {
    super();
  }

  /**
   * Handler for the copy process id to clipboard click event.
   */
  onCopyProcessIdToClipboard(): void {
    this.clipboard.copy(this.searchResult().workflowProcessId.toString());
    this.notify.success('PROCESS_ID_COPIED_TO_CLIPBOARD');
  }
}
